import type { ZodSchema } from "zod";

import {
	customerSchema,
	laeSchema,
	ltlOwnerSchema,
} from "~/shared/schemas/customer-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";

export type InternalUserFilter = {
	id: number;
	name: string;
	endpoint: string;
	schema: ZodSchema<unknown> | null;
	paramType: string;
};

/**
 * User filter options shown to internal users on the Shipment Board:
 * LTL AR / LAE / Customer.
 */
export const internalUserFilters: InternalUserFilter[] = [
	{
		id: 1,
		name: "LTL AR",
		endpoint: apiRoutes.GETLTLBROKERS,
		schema: ltlOwnerSchema.array(),
		paramType: "ltlBrokers",
	},
	{
		id: 2,
		name: "LAE",
		endpoint: apiRoutes.GETPRIMARYBROKERS,
		schema: laeSchema.array(),
		paramType: "laes",
	},
	{
		id: 3,
		name: "Customer",
		endpoint: apiRoutes.CUSTOMERSEARCH,
		schema: customerSchema.array(),
		paramType: "customers",
	},
];
